import { cache, mutate } from 'swr';
import globToRegExp from 'glob-to-regexp';

function mutateMany(select, data, shouldRevalidate) {
  if (shouldRevalidate === void 0) {
    shouldRevalidate = true;
  } // get all cache keys


  var keys = cache.keys();
  var mutations = [];

  for (var _iterator = keys, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
    var _ref;

    if (_isArray) {
      if (_i >= _iterator.length) break;
      _ref = _iterator[_i++];
    } else {
      _i = _iterator.next();
      if (_i.done) break;
      _ref = _i.value;
    }

    var key = _ref; // ignore keys which doesn't pass the condition

    if (typeof select === 'function' && !select(key)) continue;

    if (typeof select === 'string' && !globToRegExp(select).test(key)) {
      continue;
    } // get shouldRevalidate value


    var _shouldRevalidate = typeof shouldRevalidate === 'function' ? shouldRevalidate(key, cache.get(key)) : shouldRevalidate; // call mutate and add the resulting promise to the mutations array


    mutations.push(mutate(key, data, _shouldRevalidate));
  } // returns the mutations array so we could wait for every mutation


  return Promise.all(mutations);
}

export { mutateMany };